/**
 * Focus the modal behind the active modal
 */
export const modalFocus = () => {
  let modals = document.getElementsByClassName('bto-sb-modalbox');
  if (modals && modals.length > 1) {
    modals[modals.length - 2].focus();
  }
};
